import React from "react";
import { Button } from "@mui/material";
import { AiIcon } from "../../../VectorIcons/AiIcon";
import "./AiButton.scss";

export function AiButton({ label = "Usar IA", onClick, disabled = false }) {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      startIcon={<AiIcon />}
      className="ai-button"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        padding: "14px 16px",
        borderRadius: "4px",
        border: "2px solid #b03efa",
        backgroundColor: "#faf5fd",
        color: "#b03efa",
        fontSize: "16px",
        textTransform: "none",
        transition: "all 200ms ease-in-out",

        "&:hover": {
          backgroundColor: "rgba(179, 102, 255, 0.3)",
          borderColor: "#9B4FD6",
        },

        "&:active": {
          backgroundColor: "rgba(179, 102, 255, 0.15)",
        },

        "&:disabled": {
          opacity: 0.5,
          cursor: "not-allowed",
        },

        "&:focus-visible": {
          outline: "none",
          boxShadow: "0 0 0 4px rgba(179, 102, 255, 0.18)",
        },
      }}
    >
      {label}
    </Button>
  );
}
